//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { ReportPanel    } from './components/ReportPanel/ReportPanel';
import { SchedulerPanel } from './components/SchedulerPanel/SchedulerPanel';

//#endregion

//-----------------------------------------------------------------
function Stats() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      backgroundColor: 'var(--bg-color-secondary)',
      padding: '1rem',
      width: '100%',
      display: 'inline-block',
    }
  }

  // === ATTRIBUTES ===
  const
    CONTAINER = {
      sx: _styles.container,
    };


  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <SchedulerPanel />
        <ReportPanel    />
      </Box>
    );
  }

  //#endregion

  return display();
}

export { Stats };
